export default {
    ORDER_ID_CARD_BEGIN: 'ORDER_ID_CARD_BEGIN',
    ORDER_ID_CARD_SUCCESS: 'ORDER_ID_CARD_SUCCESS',
    ORDER_ID_CARD_ERROR: 'ORDER_ID_CARD_ERROR',
    ORDER_ID_CARD_CLEANUP: 'ORDER_ID_CARD_CLEANUP'
};